import { render, staticRenderFns } from "./top-bar.vue?vue&type=template&id=227d5252&scoped=true"
import script from "./top-bar.vue?vue&type=script&lang=js"
export * from "./top-bar.vue?vue&type=script&lang=js"
import style0 from "./top-bar.vue?vue&type=style&index=0&id=227d5252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227d5252",
  null
  
)

export default component.exports